module.exports = __webpack_public_path__ + "5b98f6f3041409dd54d4684ef14a9876.png";